import { defineMessages } from '@redbubble/next/intl';

export const messages = defineMessages({
  standardShipping: {
    defaultMessage: 'Standard Shipping',
  },
  expressShipping: {
    defaultMessage: 'Express Shipping',
  },
  flatRateShipping: {
    defaultMessage: 'Flat Shipping Rate',
  },
  dateRange: {
    defaultMessage: 'Between {dateRange}',
  },
  dateBy: {
    defaultMessage: 'By {date}',
  },
  daysLeft: {
    defaultMessage:
      '<bold>{number} days left</bold> to get it by <bold>{targetDate}</bold>',
  },
  orderToday: {
    defaultMessage:
      'Order <bold>today</bold> by 11:59PM to get it by <bold>{targetDate}</bold>',
  },
});
